import type { LocalSettings } from "@app/config/LocalSettings";
import localSettings from "@app/config/LocalSettings";

class ResourcesSettings {
  settings: LocalSettings;

  private readonly OAUTH_CONNECTION_ID = "__OAUTH_CONNECTION_ID__";

  constructor(settings: LocalSettings) {
    this.settings = settings;
  }

  getOAuthConnectionData = (): { id: number; provider: string } | undefined => {
    const value = localStorage.getItem(this.OAUTH_CONNECTION_ID);
    if (!value) {
      return undefined;
    }
    try {
      const parsed = JSON.parse(value);
      if (parsed && typeof parsed.id === "number" && typeof parsed.provider === "string") {
        return parsed;
      }
    } catch {
      return undefined;
    }
  };

  setOAuthConnectionData = (id: number, provider: string) => {
    localStorage.setItem(this.OAUTH_CONNECTION_ID, JSON.stringify({ id, provider }));
  };

  clearOAuthConnectionData = () => {
    localStorage.removeItem(this.OAUTH_CONNECTION_ID);
  };
}

const resourcesSettings = new ResourcesSettings(localSettings);

export default resourcesSettings;
